function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import 'cross-fetch/polyfill';
import { EMAIL_CONFIG_FORM } from '@engine/actions/action-types';
/**
 * Action Creators for Email module forms
 */

export var handleDestroyResponse = function handleDestroyResponse(entity, data) {
  return {
    type: EMAIL_CONFIG_FORM(entity).entityDestroy,
    data: data
  };
};
export var updateEntity = function updateEntity(entity, data) {
  return {
    type: EMAIL_CONFIG_FORM(entity).entityUpdate,
    data: data
  };
};
export var requestFail = function requestFail(entity) {
  return {
    type: EMAIL_CONFIG_FORM(entity).requestFail
  };
};
export var submitRequest = function submitRequest(entity) {
  return {
    type: EMAIL_CONFIG_FORM(entity).requestInProgress
  };
};
export var resetForm = function resetForm(entity) {
  return {
    type: EMAIL_CONFIG_FORM(entity).reset
  };
};
export var handleResponse = function handleResponse(entity, data) {
  return {
    type: EMAIL_CONFIG_FORM(entity).responseReceive,
    data: data
  };
};
export var setCustomAttributes = function setCustomAttributes(entity, data) {
  return {
    type: EMAIL_CONFIG_FORM(entity).customAttributesReceive,
    data: data
  };
};
export function save(_ref) {
  var url = _ref.url,
      entity = _ref.entity,
      callbackOnSuccess = _ref.callbackOnSuccess,
      _ref$method = _ref.method,
      method = _ref$method === void 0 ? 'POST' : _ref$method;
  return function (dispatch, getState) {
    dispatch(submitRequest(entity));
    var formEntity = getState()["".concat(entity, "Form")].entity;

    var formData = _defineProperty({
      authenticity_token: window.CSRF
    }, entity, formEntity);

    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      dispatch(handleResponse(entity, json));

      if (!json.errors) {
        return callbackOnSuccess(json);
      }
    })["catch"](function () {
      return dispatch(requestFail(entity));
    });
  };
}
export function destroy(_ref2) {
  var url = _ref2.url,
      entity = _ref2.entity,
      callbackOnSuccess = _ref2.callbackOnSuccess,
      _ref2$method = _ref2.method,
      method = _ref2$method === void 0 ? 'DELETE' : _ref2$method;
  return function (dispatch) {
    dispatch(submitRequest(entity));
    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': window.CSRF
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      dispatch(handleDestroyResponse(entity, json));

      if (!json.errors) {
        return callbackOnSuccess();
      }
    })["catch"](function () {
      return dispatch(requestFail(entity));
    });
  };
}
export function getCustomAttributes(configurationType) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/email_configuration_attributes';
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
  return function (dispatch) {
    return fetch("".concat(url, "/").concat(configurationType), {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': window.CSRF
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(setCustomAttributes('configuration', json));
    })["catch"](function () {
      return dispatch(requestFail('configuration'));
    });
  };
}